import withRedux from "../withRedux";
import { codeLogin } from "../actions";

const Code = ({ match, codeLogin }: { match; codeLogin }) => {
	if (match.params["code"]) {
		const code = match.params["code"];
		const redirect = match.params["redirect"];
		codeLogin(code, redirect);
	}

	return null;
};

const mapStateToProps = () => {
	return {};
};

export default withRedux({ codeLogin }, mapStateToProps)(Code);
